import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export const UIBalanceStore = Store.createStore({
    /**
     * Represents the current player balance at the current time.
     * According to the current win animations.
     */
    slot_ui_label_balance: Store.signal(0),
});